import React, { useState, useEffect } from "react";

import { func_validation, isNotNullUndefined, isObjectNotEmpty, isStringEqual_caseSensitive, isStringTrimNotEmpty } from "functions";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMinus } from '@fortawesome/free-solid-svg-icons'

import "assets/scss/components/form/formCheckbox.scss";



/* Props 
 * {
 *      // Data
 *      checkboxID: "",
 *      mainCheckboxID: "",
 * 
 *      // State managed by parent
 *      isMainCheckboxChecked: false,
 *      isMainCheckboxIndeterminate: false,
 * 
 *      // Options
 *      isCheckboxCheckedDefault: false,
 *      isCheckboxDisabled: false,
 * 
 *      // State Propagation
 *      handleCheckboxSelectionMain: (checkboxID, isCheckboxChecked_new)=>{};
 *      handleCheckboxSelectionSub: (checkboxID, isCheckboxChecked_new)=>{};
 * }
 */

export function FormCheckbox(props) {
    const { 
        className, checkboxWrapperClassName, checkboxClassName, labelClassName, checkboxIconClassName, 
        checkboxID: checkboxID_props, mainCheckboxID: mainCheckboxID_props,  
        isMainCheckboxChecked, isMainCheckboxIndeterminate: isMainCheckboxIndeterminate_props,
        checkboxLabel, isLabelOnLeftSide,
        isCheckboxDisabled, isCheckboxCheckedDefault, isDecoration_lightBackground, isResetRequired,
        isErrorRequired, isFormSubmissionAttempted, errorMsg
    } = props;

    // States

    const [checkboxID] = useState(checkboxID_props); // immutable
    const [checkboxID_main] = useState(mainCheckboxID_props); // immutable
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(isCheckboxCheckedDefault); 
    const [isMainCheckboxIndeterminate, setIsMainCheckboxIndeterminate] = useState(isMainCheckboxIndeterminate_props);

    // Determine whether current checkbox is main checkbox
    function isCurrentCheckboxMain() {
        return isStringEqual_caseSensitive(checkboxID, checkboxID_main);
    }

    function onClick_handleCheckbox() {
        let isCheckboxChecked_new = !isCheckboxChecked;

        if (isCurrentCheckboxMain()) {
            if (isCheckboxChecked_new && isMainCheckboxIndeterminate) {
                setIsCheckboxChecked(false);
                isCheckboxChecked_new = false;
            }
            else setIsCheckboxChecked(isCheckboxChecked_new);

            setIsMainCheckboxIndeterminate(false);
        }
        else setIsCheckboxChecked(isCheckboxChecked_new);

        
        /* Update Parent State */
        // If main checkbox selected
        if (isCurrentCheckboxMain() &&
            props.handleCheckboxSelectionMain)
            props.handleCheckboxSelectionMain(checkboxID, isCheckboxChecked_new);
        // If any other checkbox selected
        else if (props.handleCheckboxSelectionSub) 
            props.handleCheckboxSelectionSub(checkboxID, isCheckboxChecked_new);
    }

    // Function to update checkbox depending on whether main checkbox is checked or indeterminate or neither
    // for both main and non-main checkboxes
    function updateMainCheckboxState() {
        // Main Checkbox Checked State
        if (isCurrentCheckboxMain()) {
            setIsCheckboxChecked(isMainCheckboxChecked);
            setIsMainCheckboxIndeterminate(isMainCheckboxIndeterminate_props);
        }
        else if (!isMainCheckboxIndeterminate_props) setIsCheckboxChecked(isMainCheckboxChecked);
    }
    useEffect(() => {
        updateMainCheckboxState();
    }, [isMainCheckboxChecked, isMainCheckboxIndeterminate_props]);

    useEffect(() => {
        if (isNotNullUndefined(isCheckboxCheckedDefault))
            setIsCheckboxChecked(isCheckboxCheckedDefault);
    }, [isCheckboxCheckedDefault]);
    
    function reset() {
        if (isResetRequired)
            setIsCheckboxChecked(isCheckboxCheckedDefault);
    }
    useEffect(() => {
        reset();
    }, [isResetRequired]);

    let checkboxIcon = {};
    if (isCheckboxChecked)
        checkboxIcon = faCheck;
    else if (isCurrentCheckboxMain() && isMainCheckboxIndeterminate) {
        checkboxIcon = faMinus;
    }
    let isCheckboxIconVisible = isObjectNotEmpty(checkboxIcon);

    let label = isStringTrimNotEmpty(checkboxLabel)? (
        <div htmlFor={checkboxID} 
            className={"component-formCheckbox-label " +
                        (labelClassName? labelClassName + " ":"")} >
            {checkboxLabel}
        </div>
    ):"";

    return (
        <div className={"component-formCheckbox " +
                (className? className + " ":"")}
        >

            {/* Checkbox Wrapper */}
            <div className={"component-formCheckbox-checkboxWrapper d-flex align-items-center " +
                        (checkboxWrapperClassName? checkboxWrapperClassName + " ":"") +
                        (isDecoration_lightBackground? "component-formCheckbox-decoration_lightBackground ":"component-formCheckbox-decoration_normalLightBackground ")}>

                {/* Label */}
                {isLabelOnLeftSide? label:""}

                {/* Checkbox Input */}
                <div className={"component-formCheckbox-checkbox " + 
                                (checkboxClassName? checkboxClassName + " ":"") +
                                (!isCheckboxIconVisible? "component-formCheckbox-checkbox_unchecked ":"") +
                                (isCheckboxIconVisible? "component-formCheckbox-checkbox_checked ":"") +
                                (isCheckboxDisabled? "component-formCheckbox-checkboxWrapper_disabled ":"")} 
                    id={checkboxID} 
                    onClick={() => { if (!isCheckboxDisabled) onClick_handleCheckbox(); }}
                >
                    {isCheckboxIconVisible? (
                        <FontAwesomeIcon className={"component-formCheckbox-checkboxIcon " +
                                                    (checkboxIconClassName? checkboxIconClassName + " ":"") +
                                                    (isCheckboxChecked? "component-formCheckbox-checkboxIcon_checked ":"") +
                                                    (isMainCheckboxIndeterminate && isCurrentCheckboxMain()? "component-formCheckbox-checkboxIcon_indeterminate ":"")} 
                                        icon={checkboxIcon} />
                    ): (isCheckboxDisabled)? (
                        <FontAwesomeIcon className={"component-formCheckbox-checkboxDisabledIcon "} icon={faMinus} />
                    ):""}
                </div>

                {/* Label */}
                {!isLabelOnLeftSide? label:""}

            </div>

            {/* Error Message */}
            {(isErrorRequired && isFormSubmissionAttempted)? (
                <span className="component-formInput-errorMessage">{errorMsg}</span>
            ):""}
        </div>
    );
}